export const UserDeveloperIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <defs />
      <path
        d="M18.39,11.606a6.826,6.826,0,0,0-5.1,2.37,4.969,4.969,0,0,0-2.15-4.069A4.888,4.888,0,0,1,14,9,4.994,4.994,0,0,1,18.39,11.606Z"
        fill="#00e6ca"
      />
      <path d="M7.5,23.5l.5-6h2.5V14a5,5,0,0,0-10,0v3.5H3l.5,6Z" fill="#c4f0eb" />
      <circle cx={5.5} cy={4} r={3.5} fill="#c4f0eb" />
      <circle cx={14} cy={4.5} r={3} fill="#00e6ca" />
      <path d="M10.5,14v1.83a5,5,0,1,0-10,0V14a5,5,0,0,1,10,0Z" fill="#f8fafc" />
      <path
        d="M12.361,11.11a4.913,4.913,0,0,1,4.561.671,6.825,6.825,0,0,1,1.468-.175A4.994,4.994,0,0,0,14,9a4.894,4.894,0,0,0-2.86.91A5.005,5.005,0,0,1,12.361,11.11Z"
        fill="#c4f0eb"
      />
      <path
        d="M5.5,2.329A3.49,3.49,0,0,1,8.864,4.915,3.466,3.466,0,0,0,9,4,3.5,3.5,0,0,0,2,4a3.466,3.466,0,0,0,.136.915A3.49,3.49,0,0,1,5.5,2.329Z"
        fill="#f8fafc"
      />
      <path
        d="M14,3.329a2.99,2.99,0,0,1,2.843,2.086,3,3,0,1,0-5.686,0A2.99,2.99,0,0,1,14,3.329Z"
        fill="#c4f0eb"
      />
      <path
        d="M7.5,23.5l.5-6h2.5V14a5,5,0,0,0-10,0v3.5H3l.5,6Z"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <circle
        cx={5.5}
        cy={4}
        r={3.5}
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M17.439,10.37a5.006,5.006,0,0,0-5.561-.9"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <circle
        cx={14}
        cy={4.5}
        r={3}
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <circle
        cx={18.5}
        cy={18.5}
        r={5}
        fill="#00e6ca"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <polyline
        points="19.5 17 21 18.5 19.5 20"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <polyline
        points="17.5 17 16 18.5 17.5 20"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
};
